import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { isNullOrUndefined } from '@utils/utils';
import { ReservationsDataOutDTO } from '@api/ringil-api.v2';
import SvgBill from '@icons/bill.svg?react';

interface Props {
  events: any[];
}

/** One-line summary under the filter: reservation count + planned manipulation units per cargo type. */
export const CalendarSummary: React.FC<Props> = ({ events }) => {
  const { tr } = useTranslationLgs();

  const reducedCounts = events
    .flatMap((t: ReservationsDataOutDTO) => t?.orders)
    .flatMap(t => t?.items)
    .reduce((acc, t) => {
      if (isNullOrUndefined(acc[t.cargoTemplate.name])) {
        acc[t.cargoTemplate.name] = t.amount;
      } else {
        acc[t.cargoTemplate.name] += t.amount;
      }
      return acc;
    }, {} as { [key: string]: number });

  return (
    <div className="flex text-content-gr4 items-center text-xs mb-4">
      <SvgBill className="mr-2" />
      <p>
        <strong>{tr('TimeslotReservations.ReservationsAmount', 'Reservations Amount')}:</strong> {events.length}&nbsp;|&nbsp;
      </p>
      <p>
        <strong>{tr('TimeslotReservations.PlannedManipulationUnits', 'Planned Manipulation Units')}</strong>:&nbsp;
        {Object.keys(reducedCounts)
          .map(t => `${reducedCounts[t]} ${t}`)
          .join(', ')}
        {Object.keys(reducedCounts).length == 0 && <>{tr(`Calendar.zatimNic`, `Zatim nic`)}</>}
      </p>
    </div>
  );
};